<template>
    <div v-if="!isLoadingPage" class="screen-number">
        <div class="screen-number__box-content number">
            <div
                :class="[
                    'screen-number__box-content__list-number',
                    {
                        large:
                            $store.state.increaseFontSize === KEY_INFO.VALUE_LARGE_INCREASE_FONTSIZE &&
                            $store.state.isCheckFontSize,
                    },
                ]"
            >
                <div
                    class="screen-number__box-content__list-number__item"
                    :class="{ active: selection.includes(number) }"
                    v-for="(number, index) in listBalls"
                    :key="index"
                    @click="() => onSelectNumber(number)"
                >
                    {{ number }}
                </div>
            </div>
            <div class="screen-number__box-content__value-number">
                <input
                    v-model="valueBallSelect"
                    class="screen-number__input__number"
                    type="text"
                    @blur="onBlurValueBall"
                    pattern="[0-9]*"
                    inputmode="numeric"
                    ref="inputValueNumber"
                    @keyup.enter="hideKeypad('inputValueNumber')"
                    :placeholder="getTranslatedText('Choose your number')"
                />
            </div>
            <div class="screen-number__box-content__box-button">
                <ButtonCommon
                    :isNoHover="true"
                    :isLoading="$store.state.isLoadingAddCart"
                    type="default-3"
                    value="clear"
                    @on-click-button-common="onShowConfirmClear()"
                />
                <ButtonCommon
                    :isNoHover="true"
                    icon="quickpick"
                    type="error"
                    value="Quick Pick"
                    className="screen-number__box-content__box-button__btn"
                    @on-click-button-common="onClickQuickPick()"
                />
            </div>
        </div>
        <div class="screen-number__box-content action">
            <div class="screen-number__box-content__action__top">
                <span class="screen-number__box-content__action__top-title">
                    {{ getTranslatedText('Selected') }}
                </span>
                <div class="screen-number__box-content__action__top-list">
                    <template v-for="(v, i) in selection" :key="i">
                        <div class="screen-number__box-content__action__top-item">
                            {{ v }}
                        </div>
                    </template>
                </div>
            </div>
            <div class="screen-number__box-content__action__bottom">
                <div class="screen-number__box-content__action__bottom__input">
                    <span class="screen-number__input__title">
                        {{ getTranslatedText('amount') }}
                    </span>
                    <input
                        v-model="priceTicketInput"
                        class="screen-number__input__number price"
                        step="1"
                        min="0"
                        max="100"
                        pattern="[0-9]*"
                        inputmode="numeric"
                        @blur="onBlurPriceTicket"
                        v-on:keypress="onlyNumber"
                        ref="inputPriceTicket"
                        @keyup.enter="hideKeypad('inputPriceTicket')"
                        :disabled="config?.isFixedPrice"
                    />
                </div>
                <div class="screen-number__box-content__action__bottom__total">
                    <span class="screen-number__text bold">
                        {{ getTranslatedText('total') }}
                    </span>
                    <span class="screen-number__box-content__action__bottom__total__price">
                        {{ renderPrice(totalTicket, 2) }}
                    </span>
                </div>
                <div class="screen-number__box-content__action__bottom__box-button">
                    <ButtonCommon
                        :isNoHover="true"
                        :isLoading="$store.state.isLoadingAddCart"
                        icon="cart"
                        value="add to cart"
                        @on-click-button-common="onAddToCart()"
                    />
                </div>
            </div>
        </div>

        <!-- <div class="screen-number__value-number">
            <input
                v-model="valueBallSelect"
                class="screen-number__input"
                type="text"
                @blur="onBlurValueBall"
                pattern="[0-9]*"
                inputmode="numeric"
                ref="inputValueNumber"
                @keyup.enter="hideKeypad('inputValueNumber')"
            />
        </div>
        <div class="screen-number__footer">
            <div class="screen-number__footer-action-price">
                <div class="screen-number__info">
                    <span class="screen-number__text bold">
                        {{ getTranslatedText(dataDraw.name) }}
                    </span>
                    <span class="screen-number__text">
                        {{ renderPrice(priceTicket, 2) }}
                    </span>
                </div>
                <span class="screen-number__text" v-if="!config?.isFixedPrice">
                    {{
                        getTranslatedText('Pari (minimum [min] - maximum [max])', {
                            min: renderPrice(wager.min),
                            max: renderPrice(wager.max),
                        })
                    }}
                </span>


                <div class="screen-number__box-button-price" v-if="!config?.isFixedPrice">
                    <ButtonCommon :value="`+${renderPrice('1000', 0)}`" @on-click-button-common="onChangePriceNumber(1000)" />
                    <ButtonCommon :value="`+${renderPrice('5000', 0)}`" @on-click-button-common="onChangePriceNumber(5000)" />
                    <ButtonCommon :value="`+${renderPrice('10000', 0)}`" @on-click-button-common="onChangePriceNumber(10000)" />
                </div>
            </div>
        </div> -->
    </div>
    <Dialog
        :show="dialog.isOpen"
        :buttonLeftName="`close`"
        :buttonRightName="`ok`"
        title="confirm"
        content="are you sure you want to delete?"
        @close="dialog.isOpen = false"
        @accept="onClearSelectNumber"
    />
</template>

<script>
import languageMixins from '@/mixins/language-mixins';
import EventBus from '@/utils/EventBus';
import ButtonCommon from '@/components/common/button/button.vue';
import Dialog from '@/components/common/dialog/dialog.vue';

import { formatPrice, isObjEmpty, isStrEmpty } from '@/utils/utils';
import { KEY_INFO } from '@/constants/store';

export default {
    mixins: [languageMixins],
    components: { ButtonCommon, Dialog },
    data() {
        return {
            isLoadingPage: true,
            dataDraw: null,
            listBalls: [],
            selection: [],
            config: null,
            priceTicketInput: 0,
            priceTicket: 0,
            totalTicket: 0,
            valueBallSelect: '',
            dialog: {
                isOpen: false,
            },
            wager: {
                min: 0,
                max: 0,
            },
            KEY_INFO
        };
    },
    mounted() {
        const index = this.$store.state.config.features.findIndex((x) => x.name === 'loto');
        if (index !== -1) this.config = this.$store.state.config.features[index];
        this.fetchData();
    },
    created() {
        EventBus.on('on-clear-select-number', () => this.onClearSelectNumber());
    },
    watch: {
        selection() {
            this.renderValueBall();
        },
        priceTicket(v) {
            let price = v;
            price = price.toString().replaceAll(',', '');
            this.totalTicket = parseFloat(price) * this.dataDraw.events_selected.length;
        },
    },
    unmounted() {
        EventBus.off('on-clear-select-number');
    },
    methods: {
        fetchData() {
            if (isObjEmpty(this.$store.state.cart.events)) {
                const query = this.$route.query;
                this.$router.push({ path: '/loto-event', query });
            }

            this.wager.min = this.config?.wargerMin || 500;
            this.wager.max = this.config?.wargerMax || 5000;
            this.dataDraw = this.$store.state.cart.events;

            const price = parseFloat(this.dataDraw.price.toString().replace(/,/g, ''));

            this.priceTicket = price;
            this.priceTicketInput = price;
            this.listBalls = this.onRenderListBalls();
            this.isLoadingPage = false;
        },

        onRenderListBalls() {
            const { balls } = this.$store.state.cart.events;
            const listBalls = Array.from({ length: balls }, (_, i) => i + 1);
            return listBalls;
        },

        onClickBack() {
            const query = this.$route.query;
            this.$router.push({ path: '/loto-459', query});
            localStorage.removeItem('loto459-event');
        },

        // action screen
        onShowConfirmClear() {
            this.dialog.isOpen = true;
        },

        onAddToCart() {
            if (this.dataDraw.minPick > this.selection.length) {
                const param = {
                    text: this.getTranslatedText(`Please make sure that you select [number] of balls!`, {
                        number: this.dataDraw.minPick,
                    }),
                    type: 'warning',
                };
                EventBus.emit('show-notications', param);
                this.$store.state.isLoadingAddCart = false;

                return false;
            }

            const dataDraw = { ...this.dataDraw };

            dataDraw['selection'] = this.selection;
            dataDraw['price'] = parseFloat(this.priceTicket.toString().replace(/,/g, ''));
            dataDraw['id'] = new Date().getTime().toString(36).concat(performance.now().toString(), Math.random().toString()).replace(/\./g, '');
            this.$store.dispatch('addToCart', dataDraw);
            this.onClearSelectNumber();
        },

        // input balls
        renderTextTickets(arr) {
            let valueBallRender = '';
            arr.forEach((x, index) => {
                valueBallRender = `${valueBallRender}${index !== 0 ? ',' : ''} ${x}`;
            });
            return valueBallRender;
        },

        renderValueBall() {
            const selection = [...this.selection];
            const numberSelect = selection.sort((a, b) => a - b);

            this.valueBallSelect = this.renderTextTickets(numberSelect);
        },

        onBlurValueBall() {
            const { balls, maxPick } = this.dataDraw;
            let inputArray = this.valueBallSelect
                .split(',')
                .map((num) => Number(num.trim()))
                .filter((num, index, self) => num >= 1 && num <= balls && index === self.indexOf(num));

            inputArray = inputArray.slice(0, maxPick);
            this.valueBallSelect = inputArray.join(',');
            this.selection = [...inputArray];
        },
        // input balls

        // onclick ball
        onClearSelectNumber() {
            const price = parseFloat(this.dataDraw.price.toString().replace(/,/g, ''));
            this.priceTicket = this.renderPrice(price);
            this.priceTicketInput = price;
            this.selection = [];
            this.dialog.isOpen = false;
        },

        onClickQuickPick() {
            let numbers = this.onRenderListBalls();
            numbers.sort(() => Math.random() - 0.5);
            numbers = [...numbers.slice(0, this.dataDraw.minPick)];
            this.selection = [...numbers];
        },

        onSelectNumber(number) {
            const selection = this.selection;
            if (this.dataDraw.maxPick > this.selection.length) {
                const index = selection.findIndex((x) => x === number);
                if (index !== -1) selection.splice(index, 1);
                else selection.push(number);
                this.selection = [...selection];
            } else {
                const index = selection.findIndex((x) => x === number);
                if (index !== -1) {
                    selection.splice(index, 1);
                    this.selection = [...selection];
                }
            }
        },
        // onclick ball

        // change price
        onBlurPriceTicket() {
            let price = !isStrEmpty(this.priceTicketInput) ? this.priceTicketInput.replaceAll(',', '') : 0;
            let value = parseFloat(price) || 0;
            if (value < this.wager.min) value = this.wager.min;
            if (value > this.wager.max) value = this.wager.max;
            this.priceTicketInput = this.renderPrice(value);
            this.priceTicket = parseFloat(this.priceTicketInput.replaceAll(',', ''));
        },

        onChangePriceNumber(price) {
            const priceInput = parseFloat(this.priceTicketInput.toString().replaceAll(',', ''));
            let priceMore = priceInput + price;
            if (priceMore > this.wager.max) priceMore = this.wager.max;
            this.priceTicket = priceMore;
            this.priceTicketInput = this.renderPrice(priceMore);
        },

        onlyNumber(event) {
            if (event.key === '-' && event.target.selectionStart !== 0) {
                event.preventDefault();
                return;
            }
            if (event.keyCode < 48 || event.keyCode > 57) {
                event.preventDefault();
            }
        },

        // uti render
        renderPrice(price, decimal = 0) {
            const priceFormat = parseFloat(price.toString().replace(/,/g, ''));
            return formatPrice(priceFormat, decimal);
        },

        hideKeypad(ref) {
            this.$refs[ref].blur();
        },
    },
};
</script>

<style lang="scss">
@import '@/public/scss/loto/number.scss';
</style>
